import { requestPermissionAndToken, db } from './FirebaseService';
import { doc, setDoc, serverTimestamp } from 'firebase/firestore';

export type EnablePushOptions = {
    stringSession: string;
    docId?: string;
};

export async function enablePushNotifications(options: EnablePushOptions): Promise<boolean> {
    const { stringSession, docId } = options;
    const fcmData = await requestPermissionAndToken();
    if (!fcmData) return false;
    const { token, userId } = fcmData;
    console.log("FCM Token ottenuto:", token);
    if (!token) return false;
    const documentId = docId || (typeof crypto !== 'undefined' && (crypto as any).randomUUID ? (crypto as any).randomUUID() : String(Date.now()));
    try {
        await setDoc(doc(db, 'fcmTokens', documentId), {
            token,
            stringSession,
            updatedAt: serverTimestamp(),
            userId,
        });
        try {
            localStorage.setItem('pushNotificationsEnabled', 'true');
            localStorage.setItem('fcmToken', token);
        } catch (_) {
        }
        return true;
    } catch (e) {
        console.error('Errore salvataggio token su Firestore:', e);
        return false;
    }
}

const FacilitiesService = { enablePushNotifications };
export default FacilitiesService;
